"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNumberExtension = void 0;
const index_js_1 = require("../../../../../attributes/number/index.js");
const index_js_2 = require("../../../../../errors/index.js");
const index_js_3 = require("../../../../../schema/actions/parse/index.js");
const isArray_js_1 = require("../../../../../utils/validation/isArray.js");
const index_js_4 = require("../../symbols/index.js");
const reference_js_1 = require("./reference.js");
const parseNumberExtension = (attribute, inputValue, { transform = true } = {}) => {
    if ((0, index_js_4.isSum)(inputValue) && inputValue[index_js_4.$SUM] !== undefined) {
        return {
            isExtension: true,
            *extensionParser() {
                const sumElements = inputValue[index_js_4.$SUM];
                if (!(0, isArray_js_1.isArray)(sumElements) || sumElements.length !== 2) {
                    const { path } = attribute;
                    throw new index_js_2.DynamoDBToolboxError('parsing.invalidAttributeInput', {
                        message: `Sum for number attribute ${path !== undefined ? `'${path}' ` : ''}should be a tuple of length 2`,
                        path,
                        payload: { received: inputValue[index_js_4.$SUM] }
                    });
                }
                const [left, right] = sumElements;
                const parsers = [
                    new index_js_3.Parser((0, index_js_1.number)({ big: attribute.big }).freeze(`${attribute.path}[$SUM][0]`)).start(left, { fill: false, transform, parseExtension: reference_js_1.parseReferenceExtension }),
                    new index_js_3.Parser((0, index_js_1.number)({ big: attribute.big }).freeze(`${attribute.path}[$SUM][1]`)).start(right, { fill: false, transform, parseExtension: reference_js_1.parseReferenceExtension })
                ];
                const parsedValue = { [index_js_4.$SUM]: parsers.map(parser => parser.next().value) };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = { [index_js_4.$SUM]: parsers.map(parser => parser.next().value) };
                return transformedValue;
            }
        };
    }
    if ((0, index_js_4.isSubtraction)(inputValue) && inputValue[index_js_4.$SUBTRACT] !== undefined) {
        return {
            isExtension: true,
            *extensionParser() {
                const subtractElements = inputValue[index_js_4.$SUBTRACT];
                if (!(0, isArray_js_1.isArray)(subtractElements) || subtractElements.length !== 2) {
                    const { path } = attribute;
                    throw new index_js_2.DynamoDBToolboxError('parsing.invalidAttributeInput', {
                        message: `Subtraction for number attribute ${path !== undefined ? `'${path}' ` : ''}should be a tuple of length 2`,
                        path,
                        payload: {
                            received: inputValue[index_js_4.$SUBTRACT]
                        }
                    });
                }
                const [left, right] = subtractElements;
                const parsers = [
                    new index_js_3.Parser((0, index_js_1.number)({ big: attribute.big }).freeze(`${attribute.path}[$SUBTRACT][0]`)).start(left, {
                        fill: false,
                        transform,
                        parseExtension: reference_js_1.parseReferenceExtension
                    }),
                    new index_js_3.Parser((0, index_js_1.number)({ big: attribute.big }).freeze(`${attribute.path}[$SUBTRACT][1]`)).start(right, {
                        fill: false,
                        transform,
                        parseExtension: reference_js_1.parseReferenceExtension
                    })
                ];
                const parsedValue = { [index_js_4.$SUBTRACT]: parsers.map(parser => parser.next().value) };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = { [index_js_4.$SUBTRACT]: parsers.map(parser => parser.next().value) };
                return transformedValue;
            }
        };
    }
    if ((0, index_js_4.isAddition)(inputValue) && inputValue[index_js_4.$ADD] !== undefined) {
        const parser = new index_js_3.Parser((0, index_js_1.number)({ big: attribute.big }).freeze(`${attribute.path}[$ADD]`)).start(inputValue[index_js_4.$ADD], {
            fill: false,
            transform,
            parseExtension: reference_js_1.parseReferenceExtension
        });
        return {
            isExtension: true,
            *extensionParser() {
                const parsedValue = { [index_js_4.$ADD]: parser.next().value };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = { [index_js_4.$ADD]: parser.next().value };
                return transformedValue;
            }
        };
    }
    return {
        isExtension: false,
        basicInput: inputValue
    };
};
exports.parseNumberExtension = parseNumberExtension;
